// import {
//   createContext,
//   useContext,
//   useEffect,
//   useState,
//   useCallback,
// } from "react";

// import api from "../api/axios";
// import { syncCookieConsentToUser } from "../utils/cookieConsent";

// const AuthContext = createContext(null);

// const ROLE_HOME = {
//   customer: "/",
//   admin: "/master_admin_panel/",
// };

// const ALLOWED_ROLE = "customer";

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [authLoading, setAuthLoading] = useState(true);
//   const [authChecking, setAuthChecking] = useState(false);

//   const saveAccessToken = (token) => {
//     if (token) localStorage.setItem("accessToken", token);
//   };

//   const getAccessToken = () => localStorage.getItem("accessToken");

//   const clearAuth = useCallback(() => {
//     localStorage.removeItem("accessToken");
//     setUser(null);
//   }, []);

//   const redirectByRole = useCallback((role) => {
//     if (role === "admin") {
//       window.location.href = ROLE_HOME.admin;
//     }
//   }, []);

//   const setUserIfAllowed = useCallback(
//     (userData) => {
//       if (!userData) {
//         clearAuth();
//         return false;
//       }

//       if (userData.role !== ALLOWED_ROLE) {
//         clearAuth();
//         redirectByRole(userData.role);
//         return false;
//       }

//       setUser(userData);
//       return true;
//     },
//     [clearAuth, redirectByRole]
//   );

//   const verifyAccessToken = useCallback(async () => {
//     const token = getAccessToken();

//     if (!token) {
//       clearAuth();
//       return false;
//     }

//     try {
//       const res = await api.get("/auth/verify");
//       const userData = res.data?.data?.user;

//       return setUserIfAllowed(userData);
//     } catch {
//       clearAuth();
//       return false;
//     }
//   }, [clearAuth, setUserIfAllowed]);

//   const refreshAccessToken = useCallback(async () => {
//     try {
//       const res = await api.post("/auth/refresh-token");

//       const accessToken = res.data?.data?.accessToken;
//       const userData = res.data?.data?.user;

//       if (!accessToken) {
//         clearAuth();
//         return false;
//       }

//       saveAccessToken(accessToken);

//       if (userData) {
//         return setUserIfAllowed(userData);
//       }

//       return await verifyAccessToken();
//     } catch {
//       clearAuth();
//       return false;
//     }
//   }, [clearAuth, setUserIfAllowed, verifyAccessToken]);

//   const checkAuthStatus = useCallback(async () => {
//     const token = getAccessToken();

//     if (!token) {
//       clearAuth();
//       return false;
//     }

//     const valid = await verifyAccessToken();

//     if (valid) {
//       return true;
//     }

//     return await refreshAccessToken();
//   }, [verifyAccessToken, refreshAccessToken, clearAuth]);

//   const initialiseAuth = useCallback(async () => {
//     setAuthLoading(true);

//     try {
//       await checkAuthStatus();
//     } finally {
//       setAuthLoading(false);
//     }
//   }, [checkAuthStatus]);

//   const silentCheckAuthStatus = useCallback(async () => {
//     setAuthChecking(true);

//     try {
//       await checkAuthStatus();
//     } finally {
//       setAuthChecking(false);
//     }
//   }, [checkAuthStatus]);

//   const handleAuthResponse = useCallback(
//     async (res) => {
//       const accessToken = res.data?.data?.accessToken;
//       const userData = res.data?.data?.user;

//       if (!accessToken || !userData) {
//         throw new Error("Invalid auth response.");
//       }

//       saveAccessToken(accessToken);

//       const allowed = setUserIfAllowed(userData);

//       if (!allowed) {
//         throw new Error("This website is only for customers.");
//       }

//       try {
//         await syncCookieConsentToUser();
//       } catch (error) {
//         console.error("Cookie consent sync failed:", error);
//       }

//       return res.data;
//     },
//     [setUserIfAllowed]
//   );

//   const login = async ({ email, password }) => {
//     const res = await api.post("/auth/login", {
//       email,
//       password,
//     });

//     return await handleAuthResponse(res);
//   };

//   const register = async (formData) => {
//     const res = await api.post("/auth/register", formData, {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     });

//     return await handleAuthResponse(res);
//   };

//   const logout = async () => {
//     try {
//       await api.post("/auth/logout");
//     } catch (error) {
//       console.error("Logout failed:", error);
//     } finally {
//       clearAuth();
//       window.location.href = "/login";
//     }
//   };

//   useEffect(() => {
//     initialiseAuth();
//   }, [initialiseAuth]);

//   useEffect(() => {
//     let timer;

//     const run = () => {
//       clearTimeout(timer);

//       timer = setTimeout(() => {
//         silentCheckAuthStatus();
//       }, 300);
//     };

//     window.addEventListener("focus", run);

//     const onVisibilityChange = () => {
//       if (document.visibilityState === "visible") {
//         run();
//       }
//     };

//     document.addEventListener("visibilitychange", onVisibilityChange);

//     return () => {
//       window.removeEventListener("focus", run);
//       document.removeEventListener("visibilitychange", onVisibilityChange);
//       clearTimeout(timer);
//     };
//   }, [silentCheckAuthStatus]);

//   return (
//     <AuthContext.Provider
//       value={{
//         user,
//         role: user?.role || null,
//         isAuthenticated: !!user,
//         authLoading,
//         authChecking,
//         login,
//         register,
//         logout,
//         clearAuth,
//         refreshAccessToken,
//         checkAuthStatus,
//         silentCheckAuthStatus,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);



import {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";

import { useNavigate } from "react-router-dom";
import api from "../api/axios";

import { syncCookieConsentToUser } from "../utils/cookieConsent";

const AuthContext = createContext(null);

const ALLOWED_ROLE = "customer";

// Customer app
const CUSTOMER_HOME = "/";
const CUSTOMER_LOGIN = "/login";

// Admin app is on a completely different origin
const ADMIN_LOGIN = "https://console.grapheweddings.com/login";

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [authChecking, setAuthChecking] = useState(false);

  const saveAccessToken = (token) => {
    if (token) {
      localStorage.setItem("accessToken", token);
    }
  };

  const getAccessToken = () => {
    return localStorage.getItem("accessToken");
  };

  const clearAuth = useCallback(() => {
    localStorage.removeItem("accessToken");
    setUser(null);
  }, []);

  /**
   * Redirect users according to their role.
   *
   * customer:
   * stays on grapheweddings.com
   *
   * admin:
   * moves to console.grapheweddings.com
   */
  const redirectByRole = useCallback(
    (role) => {
      if (role === "customer") {
        navigate(CUSTOMER_HOME, {
          replace: true,
        });

        return;
      }

      if (role === "admin") {
        window.location.replace(ADMIN_LOGIN);
        return;
      }

      navigate(CUSTOMER_LOGIN, {
        replace: true,
      });
    },
    [navigate]
  );

  const setUserIfAllowed = useCallback(
    (userData) => {
      if (!userData) {
        clearAuth();
        return false;
      }

      // Someone with a non-customer account
      // is trying to use the customer website.
      if (userData.role !== ALLOWED_ROLE) {
        clearAuth();

        redirectByRole(userData.role);

        return false;
      }

      setUser(userData);

      return true;
    },
    [clearAuth, redirectByRole]
  );

  const verifyAccessToken = useCallback(async () => {
    const token = getAccessToken();

    if (!token) {
      clearAuth();
      return false;
    }

    try {
      const res = await api.get("/auth/verify");

      const userData =
        res.data?.data?.user;

      return setUserIfAllowed(userData);
    } catch (error) {
      clearAuth();

      return false;
    }
  }, [clearAuth, setUserIfAllowed]);

  const refreshAccessToken = useCallback(async () => {
    try {
      const res = await api.post(
        "/auth/refresh-token"
      );

      const accessToken =
        res.data?.data?.accessToken;

      const userData =
        res.data?.data?.user;

      if (!accessToken) {
        clearAuth();
        return false;
      }

      saveAccessToken(accessToken);

      if (userData) {
        return setUserIfAllowed(userData);
      }

      return await verifyAccessToken();
    } catch (error) {
      clearAuth();

      return false;
    }
  }, [
    clearAuth,
    setUserIfAllowed,
    verifyAccessToken,
  ]);

  const checkAuthStatus = useCallback(async () => {
    const token = getAccessToken();

    if (!token) {
      clearAuth();
      return false;
    }

    const valid =
      await verifyAccessToken();

    if (valid) {
      return true;
    }

    return await refreshAccessToken();
  }, [
    verifyAccessToken,
    refreshAccessToken,
    clearAuth,
  ]);

  const initialiseAuth = useCallback(async () => {
    setAuthLoading(true);

    try {
      await checkAuthStatus();
    } finally {
      setAuthLoading(false);
    }
  }, [checkAuthStatus]);

  const silentCheckAuthStatus = useCallback(async () => {
    setAuthChecking(true);

    try {
      await checkAuthStatus();
    } finally {
      setAuthChecking(false);
    }
  }, [checkAuthStatus]);

  /**
   * Handles both:
   * - customer login
   * - customer registration
   */
  const handleAuthResponse = useCallback(
    async (res) => {
      const accessToken =
        res.data?.data?.accessToken;

      const userData =
        res.data?.data?.user;

      if (!accessToken || !userData) {
        throw new Error(
          "Invalid auth response."
        );
      }

      /**
       * IMPORTANT:
       * Validate role BEFORE storing the token.
       */
      if (userData.role !== ALLOWED_ROLE) {
        clearAuth();

        if (userData.role === "admin") {
          window.location.replace(
            ADMIN_LOGIN
          );

          throw new Error(
            "Please login through the admin panel."
          );
        }

        throw new Error(
          "This website is only for customers."
        );
      }

      // Correct customer
      saveAccessToken(accessToken);

      setUser(userData);

      /**
       * Associate previously selected
       * cookie consent with this user.
       */
      try {
        await syncCookieConsentToUser();
      } catch (error) {
        console.error(
          "Cookie consent sync failed:",
          error
        );
      }

      return res.data;
    },
    [clearAuth]
  );

  const login = async ({
    email,
    password,
  }) => {
    const res = await api.post(
      "/auth/login",
      {
        email,
        password,
      }
    );

    return await handleAuthResponse(res);
  };

  const register = async (formData) => {
    const res = await api.post(
      "/auth/register",
      formData,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }
    );

    return await handleAuthResponse(res);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (error) {
      console.error(
        "Logout failed:",
        error
      );
    } finally {
      clearAuth();

      /**
       * Same-domain React navigation.
       *
       * grapheweddings.com/login
       */
      navigate("/login", {
        replace: true,
      });
    }
  };

  useEffect(() => {
    initialiseAuth();
  }, [initialiseAuth]);

  /**
   * Re-check authentication when the
   * browser/tab becomes active again.
   */
  useEffect(() => {
    let timer;

    const run = () => {
      clearTimeout(timer);

      timer = setTimeout(() => {
        silentCheckAuthStatus();
      }, 300);
    };

    window.addEventListener(
      "focus",
      run
    );

    const onVisibilityChange = () => {
      if (
        document.visibilityState ===
        "visible"
      ) {
        run();
      }
    };

    document.addEventListener(
      "visibilitychange",
      onVisibilityChange
    );

    return () => {
      window.removeEventListener(
        "focus",
        run
      );

      document.removeEventListener(
        "visibilitychange",
        onVisibilityChange
      );

      clearTimeout(timer);
    };
  }, [silentCheckAuthStatus]);

  return (
    <AuthContext.Provider
      value={{
        user,
        role: user?.role || null,
        isAuthenticated: !!user,

        authLoading,
        authChecking,

        login,
        register,
        logout,

        clearAuth,
        refreshAccessToken,
        checkAuthStatus,
        silentCheckAuthStatus,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};